/*Recurso: Users - Servicio de lectura del API: información del usuario
  Tareas:
    GetUserAuth   // datos del usuario //usuado en Encabezado - PerFil
    SearchUserLDAP
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import create from "zustand";

const usersStore = create((set:any, get:any) => ({

  objErrorUsersStore: { hasError: false,  url: '',  body:'',  recurso:'users', componente:'', idresul: 0, desresul:'', menu:''}, //se llena con la información del api si éste tiene error

    //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI
    limpiaObjErrorUsersStore: () => {
        //alert('usersStore - limpiaObjErrorUsersStore:');
        let paso = { hasError: false, url:'', body:'', recurso:'users', componente:'', idresul:0, desresul:'', menu:''}
        set( { objErrorUsersStore: paso } );
        //console.log('usersStore - limpiaObjErrorUsersStore (sale) - objErrorUsersStore: ', get().objErrorUsersStore);
    },
    
    //*Error en api: entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
    generaObjErrorUsersStore: async (responseAPI:any, h:any, h2:any, e:any, c:any, m:any) => {
        //alert('usersStore - generaObjErrorUsersStore:');
        console.log('*generaObjErrorUsersStore (entra): ', responseAPI);
        console.log('*generaObjErrorUsersStore (entra): h: ', h , ' h2: ',  h2 , ' e: ', e , ' c: ', c );
        let paso = { hasError: h, url:'', body:e, recurso:'users', componente:c, idresul:0, desresul:'', menu:m }
        if (responseAPI==undefined  || responseAPI=='Error: Network Error'){
          console.log('1');
          paso.idresul=-1;
          paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
        }
        else if (responseAPI=='Error detectado por api en ret') {
          paso.desresul= h;
          paso.idresul= h2; 
        }
        else {
          let temp = responseAPI.config;
          paso.url = temp.url;
          if (responseAPI.data!="" && responseAPI.data!=null){
              //paso.idresul=responseAPI.status;
              //paso.desresul= responseAPI.statusText;
              paso.idresul=responseAPI.data.ret;
              paso.desresul= responseAPI.data.msjerror;
          }    
          else {
            
              paso.idresul= responseAPI.status;
              switch(responseAPI.status){
                //case 404:  paso.desresul= "El usuario no existe"; break;
                case 401:  paso.desresul= "No autorizado"; break;
                case 404:  paso.desresul= "No tiene información, error al leer la tarea del API"; break;
                default: paso.desresul= responseAPI.statusText; break;
              }
          }    
        }
        set( { objErrorUsersStore: paso } );
        console.log('*generaObjErrorUsersStore (sale) - objErrorUsersStore: ', get().objErrorUsersStore);
    },

  getUserAuthStore: [],  //guarda response.data

    //*Tarea: GetUserAuthStore, guardo el resultado de api en elementos store
    // se ejecuta al entrar del Encabezado - Icono Usario o identificación del Usuario - Menu-Pefil en un useEffect, 
    // carga los datos del usuario
    guardaGetUserAuthStore: async (responseAPI:any) => {  
      //console.log('guardaGetUserAuthStore - responseAPI:', responseAPI)
      set( { getUserAuthStore: responseAPI.data } );
      //console.log ('getUserAuthStore: ', get().getUserAuthStore )
    },
  
  usuariosLDAPStore: [],  //guarda response.data

    //*Tarea: SearchUserLDAP, guardo el resultado de api en elementos store
    // se ejecuta desde Configuración - Alta de usuarios proponentes - Editar - opción Usuarios especificiso - input + botón Buscar
    guardaSearchUserLDAPStore: async (responseAPI:any) => {  
      if ( responseAPI.ret==1 ) { //inserto sin error
        set( { usuariosLDAPStore: responseAPI.item} );
        let pos = 0;
        let dato = '';
        let correo = '';
        get().usuariosLDAPStore.map((u:any, indexU:any) => {
             correo = '';
             dato = '';
             dato = u.email;
             pos = dato.indexOf('@');
             correo = u.email.substr(0, pos );
             u.email = correo.toUpperCase()
        });  
        
        //console.log('usuariosLDAPStore:', get().usuariosLDAPStore);
        return(get().usuariosLDAPStore);
      }
      else {
        get().generaObjErroUsersStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'users.store-guardaSearchUserLDAPStore')
      }
    },   

}));

export default usersStore;
